import './global/global-jquery';
import './global/global-chart';
import './global/global-waves';
import DataTable from './plugins/dataTables';
// import 'bootstrap/dist/js/bootstrap.bundle';
import './validate/_preventSameURL';
import './validate/_acceptNumberOnly';
import './layout/_waves';
import './layout/_sideNav';
import './layout/_dropdown';
import './layout/_pagination';
import './layout/_inputUpload';
import './layout/_modal';
import './layout/_countNum';

import Draggabilly from './plugins/draggability';
import charts from './pages/reports/chartjs.init';
import * as question from './pages/question/_question';
import * as groups from './pages/groups/_groups';
import * as assessment from './pages/assessment/_assessment';

// #region GLOBAL
// nav-icon drag to left, right:
const draggie = new Draggabilly('.navigation__btn', {
  axis: 'x',
  containment: '.page-wrapper',
});
// disable label select on add question
$(document).on('click', '.questionBlock .alignVertical label', function (e) {
  if (/questionadd/.test(window.location)) {
    e.preventDefault();
  }
});
//

if ($('.tablePagination').length > 0) {
  const table = new DataTable('.tablePagination');
}
// #endregion

// #region page: question
// page: question ----------------------------------------------
if (/question/.test(window.location)) {
  question.addRadio();
  $('.choicesDecrease').on('click', question.choicesDecrease);
  $('.choicesIncrease').on('click', question.choicesIncrease);
  $('#inputGroupSelect').on('change', question.changeLevel);
  $('input[name="questionlevel"]').on('click', question.changeLevel);
}
$(document).on(
  'click',
  '[contenteditable="true"]',
  question.contentEditClicked
);

// page: questionsview ------------------------------------------
if (/questionsview/.test(window.location)) {
  $('.questionBlock').each(question.questionsviewControls);
  $(document).on(
    'click',
    '.questionEdit, .questionDone',
    question.questionEdit
  );
}
// #endregion

// #region page: groups
// page: groups add -----------------------------------------------
if (/groupsadd/.test(window.location)) {
  $('#groupMember').on('keypress', groups.handleEnterKey);
  $('#addMember').on('click', groups.addMember);
  $('#groupName').on('keyup', groups.groupName);
  $(document).on('click', '.memberDelete', groups.memberDelete);
}
// page: groups view -----------------------------------------------
// #endregion

// #region page:assessment
// page: assessmentadd ---------------------------------------------------
if (/assessmentadd/.test(window.location)) {
  // set start date
  document.getElementById('assessmentDateStart').valueAsDate = new Date();
  // calc total qs
  $('.questionNumberRow td input').on(
    'keyup paste change click',
    assessment.questionTotalNumber
  );
  // get all groups from table => display in select options
  $.get('./groups.html', assessment.getGroups);
  // get group members on click => display in below div
  $(document).on(
    'click',
    '#assessmentGroupOption option',
    assessment.getGroupsMembers
  );
}
// #endregion

// #region page: reports
// page: reports -------------------------------------------------
if (/reports/.test(window.location)) {
  charts();
}
// #endregion



//////////////////
// WEBPACK FOOTER
// ./src/js/components/script.js
// module id = 2
// module chunks = 0